/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 49);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_LOCALE = exports.SET_WIDGET_CLASSES = exports.SET_VEHICLE_INFO = exports.SET_PAYMENT_INFO = exports.SET_PAGE_ALIAS = exports.SET_VEHICLE_ID = exports.SET_TAB_LIST = exports.SET_PROGRESS = void 0;
// This file should only contain action type constants.
// export const SET_FOO = 'SET_FOO';
var SET_PROGRESS = 'SET_PROGRESS';
exports.SET_PROGRESS = SET_PROGRESS;
var SET_TAB_LIST = 'SET_TAB_LIST';
exports.SET_TAB_LIST = SET_TAB_LIST;
var SET_VEHICLE_ID = 'SET_VEHICLE_ID';
exports.SET_VEHICLE_ID = SET_VEHICLE_ID;
var SET_PAGE_ALIAS = 'SET_PAGE_ALIAS';
exports.SET_PAGE_ALIAS = SET_PAGE_ALIAS;
var SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
exports.SET_PAYMENT_INFO = SET_PAYMENT_INFO;
var SET_VEHICLE_INFO = 'SET_VEHICLE_INFO';
exports.SET_VEHICLE_INFO = SET_VEHICLE_INFO;
var SET_WIDGET_CLASSES = 'SET_WIDGET_CLASSES';
exports.SET_WIDGET_CLASSES = SET_WIDGET_CLASSES;
var SET_LOCALE = 'SET_LOCALE';
exports.SET_LOCALE = SET_LOCALE;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Common", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.Common;
  }
});
Object.defineProperty(exports, "CommonTester", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.CommonTester;
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.createStore;
  }
});

var _wsmCommonData = __webpack_require__(44);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(46);

var _reactHotLoader = __webpack_require__(37);

var _Widget = _interopRequireDefault(__webpack_require__(16));

var _store = __webpack_require__(33);

var _widgetComponents = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React render bound to the redux store
 *
 * NOTE: The eslint-disable-lines are needed because this file won't lint
 * when it's in the ws-scripts repo because those files only exist in the
 * widget. It's safe because the entire application won't work if those
 * weren't really resolved. It would be really apparent quickly.
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		OSIRIS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
// eslint-disable-line import/no-unresolved
var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC.OSIRIS || !window.DDC.OSIRIS.state || !window.DDC.OSIRIS.state[widgetName]) {
    return {};
  }

  return window.DDC.OSIRIS.state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var renderWidget = function renderWidget(WidgetComponent, renderFunc, store, widgetId) {
  renderFunc(_react.default.createElement(_reactHotLoader.AppContainer, null, (0, _widgetComponents.getWidgetComponents)(WidgetComponent, store, widgetId)), document.getElementById("".concat(widgetId, "-app-root")));
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-dr-toolbox');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store;
    renderWidget(_Widget.default, _reactDom.hydrate, store, widgetId);
  });
};

if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

if (false) {
  module.hot.accept('../containers/Widget', function () {
    Object.keys(widgetIdToStore).forEach(function (widgetId) {
      var store = widgetIdToStore[widgetId];

      var ReloadedWidget = require('../containers/Widget').default; // eslint-disable-line import/no-unresolved


      renderWidget(ReloadedWidget, _reactDom.render, store, widgetId);
    });
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _environmentNode = __webpack_require__(8);

Object.keys(_environmentNode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _environmentNode[key];
    }
  });
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Webpack will replace 'logger-node' with 'logger-browser' in browser environments.
var _require = __webpack_require__(9),
    log = _require.log;
/**
 * The FATAL level designates very severe error events that will presumably lead the application to abort.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */


var fatal = function fatal(msg) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  log('FATAL', msg, data);
};
/**
 * The ERROR level designates error events that might still allow the application to continue running.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */


var error = function error(msg) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  log('ERROR', msg, data);
};
/**
 * The WARN level designates potentially harmful situations.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */


var warn = function warn(msg) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  log('WARN', msg, data);
};
/**
 * The INFO level designates informational messages that highlight the progress of the application at coarse-grained level.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */


var info = function info(msg) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  log('INFO', msg, data);
};
/**
 * The DEBUG level designates fine-grained informational events that are most useful to debug an application.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */


var debug = function debug(msg) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  log('DEBUG', msg, data);
};
/**
 * The TRACE level designates finer-grained informational events than the DEBUG level.
 * @param {(String|Error)} msg String message (or Error object) providing context for the log entry.
 * @param {Object} data Optional object whose properties will be included in the log data (as JSON).
 */


var trace = function trace(msg) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  log('TRACE', msg, data);
};

module.exports = {
  fatal: fatal,
  error: error,
  warn: warn,
  info: info,
  debug: debug,
  trace: trace
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enforceServerSide = exports.isBrowser = exports.isNode = void 0;
var isNode = false;
exports.isNode = isNode;
var isBrowser = true;
exports.isBrowser = isBrowser;

var enforceServerSide = function enforceServerSide() {
  throw new Error('You are attempting to use code in the browser that has been ' + 'designated server-side only. Such activity is known by ' + 'the state of California to lead to usage of the dark side ' + 'of the Force.');
};

exports.enforceServerSide = enforceServerSide;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = void 0;

var _loggerCommon = __webpack_require__(10);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var logLevelInt = _loggerCommon.levels[_loggerCommon.logLevel];

var browserColors = _objectSpread({}, _loggerCommon.colors, {
  FATAL: 'red; font-weight: bold'
});

var devLog = "production" !== 'production';

var log = function log(level, msg, data) {
  /* eslint-disable no-console */
  if (devLog && _loggerCommon.levels[level] <= logLevelInt) {
    var color = "color: ".concat(browserColors[level]);
    var outputStream = _loggerCommon.stderrLevels.has(level) ? console.error : console.log;
    outputStream("%c".concat(level, " : ").concat(msg), color);

    if (data) {
      outputStream("%c".concat(JSON.stringify(data, undefined, 4)), color);
    }
  }
  /* eslint-enable no-console */

};

exports.log = log;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var logLevel = __webpack_require__.i({"NODE_ENV":"production"}).LOG_LEVEL || 'INFO';
var levels = {
  FATAL: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
  TRACE: 5
};
var stderrLevels = new Set();
Object.keys(levels).forEach(function (level) {
  if (levels[level] < levels.INFO) {
    stderrLevels.add(level);
  }
});
var colors = {
  FATAL: 'red bold',
  ERROR: 'red',
  WARN: 'yellow',
  INFO: 'green',
  DEBUG: 'cyan',
  TRACE: 'blue'
};
module.exports = {
  levels: levels,
  logLevel: logLevel,
  stderrLevels: stderrLevels,
  colors: colors
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactBootstrap = __webpack_require__(45);

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HowItWorksText = function HowItWorksText(labels) {
  var extraClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return _react.default.createElement("div", {
    className: "".concat(extraClasses, " box-border p-4")
  }, _react.default.createElement("p", null, labels.get('WS_DR_TOOLBOX_TOOLTIP_INTRO')), _react.default.createElement("strong", null, _react.default.createElement("p", null, labels.get('WS_DR_TOOLBOX_TOOLTIP_DIFFERENCE_QUESTION'))), _react.default.createElement("p", null, labels.get('WS_DR_TOOLBOX_TOOLTIP_PREQUAL_INFO')), _react.default.createElement("p", {
    className: "m-0"
  }, labels.get('WS_DR_TOOLBOX_TOOLTIP_CREDIT_INFO')));
};

var HowItWorks = function HowItWorks(_ref) {
  var deviceType = _ref.deviceType,
      widgetClasses = _ref.widgetClasses;
  // const tooltipClasses =
  // 	deviceType === 'DESKTOP'
  // 		? 'dr-tooltip-container'
  // 		: 'btn btn-primary mb-3';
  var primaryBG = widgetClasses.includes('bg-primary');
  return _react.default.createElement(_common.Common, {
    render: function render(_ref2) {
      var labels = _ref2.labels;

      if (deviceType === 'DESKTOP') {
        return _react.default.createElement(_reactBootstrap.OverlayTrigger, {
          placement: "left",
          trigger: "hover",
          overlay: _react.default.createElement(_reactBootstrap.Tooltip, {
            id: "dr-toolbox-tooltip"
          }, HowItWorksText(labels))
        }, _react.default.createElement("button", {
          className: "btn btn-link dr-tooltip-container ddc-font-size-small p-0 dr-tooltip-btn mb-2 ".concat(primaryBG ? 'text-white' : '')
        }, labels.get('HOW_THIS_WORKS'), "\xA0", _react.default.createElement("i", {
          className: "ddc-icon ddc-icon-info"
        })));
      } else {
        return _react.default.createElement("div", null, _react.default.createElement("button", {
          className: "btn w-100 text-left ".concat(primaryBG ? 'btn-primary border-white' : null),
          "data-toggle": "collapse",
          "data-target": "#collapseExample",
          "aria-expanded": "false",
          "aria-controls": "collapseExample"
        }, labels.get('HOW_THIS_WORKS'), "\xA0", _react.default.createElement("i", {
          className: "ddc-icon ddc-icon-plus float-right ".concat(primaryBG ? null : 'text-primary')
        })), _react.default.createElement("div", {
          className: "collapse",
          id: "collapseExample"
        }, HowItWorksText(labels, primaryBG ? 'border-white border' : 'bg-white')));
      }
    }
  });
};

HowItWorks.propTypes = {
  deviceType: _propTypes.default.string,
  widgetClasses: _propTypes.default.string
};
HowItWorks.defaultProps = {
  deviceType: 'DESKTOP',
  widgetClasses: ''
};
var _default = HowItWorks;
exports.default = _default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InProgressButtons = function InProgressButtons() {
  var buttonClasses = 'btn btn-default btn-block btn-sm';
  return _react.default.createElement(_common.Common, {
    render: function render(_ref) {
      var labels = _ref.labels,
          sitemap = _ref.sitemap;
      return _react.default.createElement("div", {
        className: "in-progress-links-container mt-3"
      }, _react.default.createElement("div", {
        className: "in-progress-links row hide"
      }, _react.default.createElement("div", {
        className: "ddc-span12"
      }, _react.default.createElement("a", {
        className: "".concat(buttonClasses, " dialog"),
        href: sitemap.get('INVENTORY_LEAD_SCHEDULE'),
        target: "_self"
      }, labels.get('MAKE_APPOINTMENT')), _react.default.createElement("a", {
        className: buttonClasses,
        href: sitemap.get('DIRECTIONS_DEFAULT'),
        target: "_self"
      }, labels.get('GET_DIRECTIONS')))));
    }
  });
};

InProgressButtons.propTypes = {};
var _default = InProgressButtons;
exports.default = _default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(3);

var _react = _interopRequireDefault(__webpack_require__(0));

var _environment = __webpack_require__(6);

__webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Progress = function Progress() {
  var circleWidth = 4;
  var handWidth = 4;
  var height = 80;
  var width = 64;
  var percentExists = !_environment.isNode && window.DDC.digitalRetailing.percentVehicleComplete !== undefined;
  return _react.default.createElement(_common.Common, {
    render: function render(_ref) {
      var labels = _ref.labels;
      return _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-3 digital-retailing-progress circle-progress"
      }, _react.default.createElement("canvas", {
        className: "dr-clock tool-box-clock",
        "data-circle-width": circleWidth,
        "data-hand-width": handWidth,
        height: height,
        width: width
      }), _react.default.createElement("div", {
        className: "circle-color hidden"
      }), _react.default.createElement("div", {
        className: "progress-color hidden"
      }), _react.default.createElement("div", {
        className: "fill-color hidden"
      }), _react.default.createElement("div", {
        className: "enable-percent-indicator"
      }, _react.default.createElement("div", {
        className: "percentage"
      }, percentExists && "".concat(Math.round(window.DDC.digitalRetailing.percentVehicleComplete * 100.0), "%")))), _react.default.createElement("div", {
        className: "col-sm-9 intro-text-container"
      }, _react.default.createElement("p", {
        "data-dr-progress-start-text": true,
        "data-show-on-state": "start"
      }, labels.get('WS_DR_TOOLBOX_START_VERBIAGE')), _react.default.createElement("p", {
        "data-dr-progress-text": true,
        "data-show-on-state": "progress",
        className: "hide"
      }, labels.get('WS_DR_TOOLBOX_PROGRESS_VERBIAGE')), _react.default.createElement("p", {
        "data-dr-progress-complete-text": true,
        "data-show-on-state": "complete",
        className: "hide"
      }, labels.get('WS_DR_TOOLBOX_COMPLETE_VERBIAGE'))));
    }
  });
};

var _default = Progress;
exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

__webpack_require__(36);

var _HowItWorks = _interopRequireDefault(__webpack_require__(11));

var _ToolboxButtons = _interopRequireDefault(__webpack_require__(15));

var _Progress = _interopRequireDefault(__webpack_require__(13));

var _InProgressButtons = _interopRequireDefault(__webpack_require__(12));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Toolbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Toolbox, _React$Component);

  function Toolbox() {
    _classCallCheck(this, Toolbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(Toolbox).apply(this, arguments));
  }

  _createClass(Toolbox, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "ws-dr-toolbox digital-retailing-toolbox"
      }, _react.default.createElement(_HowItWorks.default, {
        deviceType: this.props.deviceType,
        widgetClasses: this.props.widgetClasses
      }), this.props.deviceType === 'DESKTOP' && _react.default.createElement(_Progress.default, null), _react.default.createElement(_InProgressButtons.default, null), _react.default.createElement(_ToolboxButtons.default, this.props));
    }
  }]);

  return Toolbox;
}(_react.default.Component);

Toolbox.propTypes = {
  deviceType: _propTypes.default.string,
  widgetClasses: _propTypes.default.string
};
Toolbox.defaultProps = {
  deviceType: 'DESKTOP',
  widgetClasses: ''
};
var _default = Toolbox;
exports.default = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _logger = _interopRequireDefault(__webpack_require__(7));

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mergeSummaryList = function mergeSummaryList(itemSummaryList, sessionSummaryList) {
  return Object.keys(itemSummaryList).reduce(function (summary, key) {
    return _objectSpread({}, summary, _defineProperty({}, key, _objectSpread({}, itemSummaryList[key], sessionSummaryList[key])));
  }, {});
}; // Generate Payment URL From info vehicle and payment info returned from VCDA


var CreatePaymentCalculatorURL = function CreatePaymentCalculatorURL(paymentInfo, vehicleInfo, locale) {
  var defaultPaymentCalcURL = '/calculator/payment-dealertrack-fragment.htm'; // Null Checks

  if (!paymentInfo || Object.keys(paymentInfo).length === 0 || !Array.isArray(paymentInfo[0].payments) || !paymentInfo[0].payments.length) {
    _logger.default.info('Create Payment Calculator URL: Fail - Missing payment info');

    return defaultPaymentCalcURL;
  } else if (!vehicleInfo || !Object.keys(vehicleInfo).length) {
    _logger.default.info('Create Payment Calculator URL: Fail - Missing vehicle info');

    return defaultPaymentCalcURL;
  } // General vehicle info


  var uuid = vehicleInfo.uuid,
      type = vehicleInfo.type,
      year = vehicleInfo.year,
      make = vehicleInfo.make,
      _vehicleInfo$model = vehicleInfo.model,
      modelType = _vehicleInfo$model === void 0 ? _defineProperty({}, locale, '') : _vehicleInfo$model,
      bodyStyle = vehicleInfo.bodyStyle,
      normalBodyStyle = vehicleInfo.normalBodyStyle,
      trim = vehicleInfo.trim,
      vin = vehicleInfo.vin,
      internetPrice = vehicleInfo.internetPrice,
      chromeId = vehicleInfo.chromeId; // Type Safe

  var bodyStyleType = _defineProperty({}, locale, '');

  if (bodyStyle) {
    bodyStyleType = bodyStyle;
  } else if (normalBodyStyle) {
    bodyStyleType = normalBodyStyle;
  }

  var trimType = _defineProperty({}, locale, '');

  if (trim) {
    trimType = trim;
  } // General payment info


  var _paymentInfo$0$paymen = paymentInfo[0].payments[0],
      excessMileageCharge = _paymentInfo$0$paymen.excessMileageCharge,
      annualMiles = _paymentInfo$0$paymen.annualMiles; // Getting Loan and Lease Specifec info
  // Mapping lowercase finance names to having first letter uppercase

  var financeTypeNameFirstUpper = {
    loan: 'Loan',
    lease: 'Lease'
  };
  var financeTypeInfo = paymentInfo[0].payments.map(function (item) {
    var financeTypeName = item.financeType === 'LOAN' ? 'loan' : 'lease';
    var isLease = item.financeType === 'LEASE';
    var lenderLegalName = item.lenderLegalName,
        downPayment = item.downPayment,
        apr = item.apr,
        term = item.term,
        payment = item.payment,
        programEndDate = item.programEndDate; // Funky String concats because linter won't let the line length go past a certain amount

    var toReturn = "&".concat(financeTypeName, "LenderName=").concat(lenderLegalName, "\n\t\t&").concat(financeTypeName, "DownPayment=").concat(downPayment, "\n\t\t&").concat(financeTypeName, "Apr=").concat(apr, "\n\t\t&").concat(financeTypeName, "Term").concat(term, "\n\t\t&payment").concat(financeTypeNameFirstUpper[financeTypeName], "=").concat(payment, "\n\t\t&").concat(financeTypeName, "ProgramEndDate=").concat(programEndDate);

    if (isLease) {
      toReturn += "&leaseSecurityDeposit=".concat(item.securityDeposit);
    }

    return toReturn;
  }); // Determine Finance Type

  var financeTypeName = '';

  if (paymentInfo[0].payments.length > 1) {
    financeTypeName = 'Loan_Lease';
  } else if (paymentInfo[0].payments[0].financeName === 'LEASE') {
    financeTypeName = 'Lease';
  } else if (paymentInfo[0].payments[0].financeName === 'LOAN') {
    financeTypeName = 'Loan';
  } // Type in payment calc URL only accepts first letter caps i.e "New" and not "NEW"


  var correctedType = type.toLowerCase();
  correctedType = correctedType.charAt(0).toUpperCase() + correctedType.slice(1);
  var paymentCalcURL = "".concat(defaultPaymentCalcURL, "?\n\tvehicleId=").concat(uuid, "\n\t&vehicleCondition=").concat(correctedType, "\n\t&year=").concat(year, "\n\t&make=").concat(make, "\n\t&model=").concat(modelType[locale], "\n\t&style=").concat(bodyStyleType[locale], "\n\t&trim=").concat(trimType[locale], "\n\t&vin=").concat(vin, "\n\t&price=").concat(internetPrice, "\n\t&financeType=").concat(financeTypeName, "\n\t&instantEpriceLabel=null\n\t&chromeId=").concat(chromeId, "\n\t&excessMileageCharge=").concat(excessMileageCharge, "\n\t&annualMiles=").concat(annualMiles, "\n\t").concat(financeTypeInfo);

  _logger.default.info('Create Payment Calculator URL: Success');

  return paymentCalcURL;
};

var ToolboxButtons =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToolboxButtons, _React$Component);

  function ToolboxButtons(props) {
    var _this;

    _classCallCheck(this, ToolboxButtons);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolboxButtons).call(this, props));
    _this.state = {
      updateCount: 0,
      isClient: false
    };
    _this.handleButtonPress = _this.handleButtonPress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleIsClient = _this.handleIsClient.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ToolboxButtons, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Set up cms-web event subscriptions and window event listeners
      // For when the user completes a DR item.
      try {
        $.subscribe('dr-state-update', function () {
          _this2.setState({
            updateCount: _this2.state.updateCount + 1
          });
        });
      } catch (err) {
        _logger.default.warn('state not subscribed to');
      } // For when mycars is logged into.


      try {
        $.subscribe('userProfile-loaded', function () {
          _this2.setState({
            updateCount: _this2.state.updateCount + 1
          });
        });
      } catch (err) {
        _logger.default.warn('my cars login not subscribed to');
      } // For when the window loads, some data fields are populated after window has loaded so we need to trigger
      // a rerender to get the data to display.


      try {
        window.addEventListener('load', function () {
          _this2.setState({
            updateCount: _this2.state.updateCount + 1
          });
        });
      } catch (err) {
        _logger.default.warn('on window load not listened to');
      } // Catching window resizing even and using it to update clock size


      window.addEventListener('resize', function () {
        $.publish('ws-dr-resize');
      });
      this.handleIsClient();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', function () {
        $.publish('ws-dr-resize');
      });
    }
  }, {
    key: "handleIsClient",
    value: function handleIsClient() {
      this.setState({
        isClient: true
      });
    }
  }, {
    key: "handleButtonPress",
    value: function handleButtonPress() {
      this.setState({
        counter: this.state.counter + 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          vehicleId = _this$props.vehicleId,
          deviceType = _this$props.deviceType,
          pageAlias = _this$props.pageAlias,
          tabList = _this$props.tabList,
          vehicleInfo = _this$props.vehicleInfo,
          paymentInfo = _this$props.paymentInfo,
          widgetClasses = _this$props.widgetClasses,
          locale = _this$props.locale;
      var paymentCalculatorURL = CreatePaymentCalculatorURL(paymentInfo, vehicleInfo, locale);
      var sessionList = null;

      if (typeof sessionStorage !== 'undefined' && JSON.parse(sessionStorage.getItem('drSummary')) !== null) {
        sessionList = JSON.parse(sessionStorage.getItem('drSummary')).summary;
      }

      var summaryList = sessionList ? mergeSummaryList(tabList, sessionList) : tabList; // Also merge the summary from the DDC object into main data object. This is because it is updated first in some edge cases.

      try {
        if (window && window.DDC && window.DDC.digitalRetailing && window.DDC.digitalRetailing.summary && summaryList) {
          summaryList = mergeSummaryList(summaryList, window.DDC.digitalRetailing.summary);
        }
      } catch (err) {
        _logger.default.warn('window.DDC.digitalRetailing.summary not found');
      }

      var mobileBtnLinks = {
        finance: '/financing/application.htm?category=AUTO' + "&vehicleId=".concat(vehicleId) + "&itemId=".concat(vehicleId) + "&referrer=".concat(pageAlias),
        prequal: '/financing/prequalification.htm?category=AUTO' + "&vehicleId=".concat(vehicleId) + "&itemId=".concat(vehicleId) + "&referrer=".concat(pageAlias),
        protect: '/digital-retailing/protect/index.htm?category=AUTO' + "&vehicleId=".concat(vehicleId) + "&itemId=".concat(vehicleId) + "&referrer=".concat(pageAlias),
        reserve: '/reserve-it-now/form.htm?category=AUTO' + "&vehicleId=".concat(vehicleId) + "&itemId=".concat(vehicleId) + "&referrer=".concat(pageAlias),
        trade: '/trade-driver/form.htm?category=AUTO' + "&vehicleId=".concat(vehicleId) + "&itemId=".concat(vehicleId) + "&referrer=".concat(pageAlias)
      };
      var stateLabels = {
        payment: 'WS_DR_TOOLBOX_PAYMENT_LABEL',
        prequal: 'SUBMITTED',
        protect: 'SELECTED',
        reserve: 'OSIRIS_RESERVED',
        trade: 'WS_DR_TOOLBOX_TRADE_LABEL',
        accessories: 'WS_DR_TOOLBOX_ACCESSORIES_LABEL',
        finance: 'APPROVED'
      }; // Helper Function to create trade label

      var getTradeLabel = function getTradeLabel(labels) {
        var tradeLabel;

        if (window.DDC && window.DDC.userProfile.ownedVehicle && window.DDC.userProfile.ownedVehicle.make && window.DDC.userProfile.ownedVehicle.year && window.DDC.userProfile.ownedVehicle.valuations && window.DDC.userProfile.ownedVehicle.valuations.length > 0) {
          var vehicleValuation = window.DDC.userProfile.ownedVehicle.valuations[window.DDC.userProfile.ownedVehicle.valuations.length - 1];
          var vehicleYear = window.DDC.userProfile.ownedVehicle.year;
          var vehicleMake = window.DDC.userProfile.ownedVehicle.make;
          var vehicleModel = vehicleValuation.thirdPartyAttributes.model;
          tradeLabel = labels.get(stateLabels.trade);
          var value = tradeLabel.substr(0, tradeLabel.indexOf(' ')).replace('[value]', window.DDC.format.currencyExtended(vehicleValuation.offer, {
            showCurrency: true
          }));
          var labelbody = tradeLabel.substr(tradeLabel.indexOf(' ') + 1).replace('[year]', vehicleYear).replace('[make]', vehicleMake).replace('[model]', vehicleModel);
          tradeLabel = _react.default.createElement("div", null, value, _react.default.createElement("br", null), _react.default.createElement("p", {
            className: "ddc-font-size-xsmall"
          }, labelbody));
        }

        return tradeLabel;
      }; // Helper function to create payment label


      var getPaymentsLabel = function getPaymentsLabel(labels) {
        var paymentsLabel;

        if (window.DDC && window.DDC.userProfile.paymentQuotes && window.DDC.userProfile.paymentQuotes[vehicleId]) {
          var currentPayment = window.DDC.userProfile.paymentQuotes[vehicleId];

          if (currentPayment && currentPayment.downPayment !== undefined && currentPayment.downPayment >= 0 && currentPayment.term !== undefined && currentPayment.term >= 0 && currentPayment.apr !== undefined && currentPayment.apr >= 0) {
            var term = "".concat(currentPayment.term);
            var apr = "".concat(currentPayment.apr, "%");
            paymentsLabel = labels.get(stateLabels.payment);
            var downPayment = paymentsLabel.substr(0, paymentsLabel.indexOf(' ')).replace('[payment]', window.DDC.format.currencyExtended(currentPayment.downPayment, {
              showCurrency: true
            }));
            var labelbody = paymentsLabel.substr(paymentsLabel.indexOf(' ') + 1).replace('[months]', term).replace('[apr]', apr);
            paymentsLabel = _react.default.createElement("div", null, downPayment, _react.default.createElement("br", null), _react.default.createElement("p", {
              className: "ddc-font-size-xsmall"
            }, labelbody));
          } else {
            paymentsLabel = 'Submitted';
          }
        }

        return paymentsLabel;
      }; // Helper function to get accessories label


      var getAccessoriesLabel = function getAccessoriesLabel(labels) {
        var accessoriesLabel;

        if (window.DDC && window.DDC.userProfile.vehicleAccessories && window.DDC.userProfile.vehicleAccessories[vehicleId] && window.DDC.userProfile.vehicleAccessories[vehicleId].accessoriesTotal != null && window.DDC.userProfile.vehicleAccessories[vehicleId].accessoriesTotal !== undefined) {
          var total = window.DDC.format.currencyExtended(window.DDC.userProfile.vehicleAccessories[vehicleId].accessoriesTotal, {
            showCurrency: true
          });
          var count = window.DDC.userProfile.vehicleAccessories[vehicleId].accessories.length;
          accessoriesLabel = labels.get(stateLabels.accessories);
          var totalLbl = accessoriesLabel.substr(0, accessoriesLabel.indexOf(' ')).replace('[total]', total);
          var labelbody = accessoriesLabel.substr(accessoriesLabel.indexOf(' ') + 1).replace('[count]', count);
          accessoriesLabel = _react.default.createElement("div", null, totalLbl, _react.default.createElement("br", null), _react.default.createElement("p", {
            className: "ddc-font-size-xsmall"
          }, labelbody));
        }

        return accessoriesLabel;
      }; // Returns a label to be shown when button is in COMPLETE state


      var getStateLabel = function getStateLabel(labels, key) {
        var stateLabel = '';

        switch (key) {
          case 'payment':
            stateLabel = getPaymentsLabel(labels);
            break;

          case 'trade':
            stateLabel = getTradeLabel(labels);
            break;

          case 'accessories':
            stateLabel = getAccessoriesLabel(labels);
            break;

          default:
            stateLabel = labels.get(stateLabels[key]);
            break;
        }

        return stateLabel;
      };

      var accessoriesURL = '/digital-retailing/accessories/index.htm?category=AUTO' + "&vehicleId=".concat(vehicleId) + "&itemId=".concat(vehicleId) + "&referrer=".concat(pageAlias);
      var primaryBG = widgetClasses.includes('bg-primary');

      var openDialogTools = function openDialogTools(key) {
        return deviceType === 'MOBILE' && ['accessories', 'payment'].includes(key) && window.pubsub.publish('openDRTools', [key]);
      };

      var DeviceTag = deviceType === 'MOBILE' ? 'a' : 'button';

      if (summaryList && this.state.isClient) {
        return _react.default.createElement(_common.Common, {
          render: function render(_ref2) {
            var labels = _ref2.labels;
            return _react.default.createElement("div", {
              className: "ddc-content dr-buttons"
            }, _react.default.createElement("ul", {
              className: "list-unstyled nav-stacked ".concat(primaryBG ? 'bg-white' : null)
            }, Object.keys(summaryList).map(function (key) {
              var item = summaryList[key];
              var itemComplete = item.vehicleComplete !== undefined ? item.vehicleComplete : item.complete;
              var BtnTag = deviceType === 'MOBILE' && ['accessories', 'payment'].includes(key) ? 'button' : DeviceTag;
              return _react.default.createElement("li", {
                className: "clearfix",
                key: key
              }, _react.default.createElement(BtnTag, {
                onClick: function onClick() {
                  return openDialogTools(key);
                },
                href: deviceType === 'MOBILE' && key !== 'payment' ? mobileBtnLinks[key] : '#',
                className: "btn btn-link text-left dr-button ".concat(primaryBG ? 'bg-white' : null, " btn-block border-bottom position-relative tool pb-1 ").concat(itemComplete ? 'complete' : 'incomplete', " ").concat(key === 'accessories' ? 'dialog' : ''),
                "data-complete": "ddc-icon-checkmark",
                "data-incomplete": "ddc-icon-checkmark",
                "data-unavailable": "ddc-icon-remove",
                "data-digital-retail-link": key,
                "data-href": key === 'accessories' ? accessoriesURL : null,
                "data-content-href": key === 'payment' ? paymentCalculatorURL : null,
                "data-digital-retail-link-type": true
              }, itemComplete && _react.default.createElement("div", {
                className: "edit small text-uppercase float-right"
              }, labels.get('EDIT')), _react.default.createElement("i", {
                className: "dr-icon ddc-icon ddc-icon-checkmark-circle icon-size-3 float-left pr-5 ".concat(itemComplete && 'text-success')
              }), _react.default.createElement("div", {
                className: "tool-summary"
              }, _react.default.createElement("h3", {
                className: "mt-0"
              }, labels.get(item.textAlias)), itemComplete && _react.default.createElement("h4", {
                className: "mt-0 text-muted"
              }, getStateLabel(labels, key)))));
            })));
          }
        });
      } else {
        return _react.default.createElement("div", null, _react.default.createElement("b", null, "Loading\xA0"), _react.default.createElement("i", {
          className: "ddc-icon ddc-icon-loading ddc-icon-size-large ddc-icon-animate-spin"
        }));
      }
    }
  }]);

  return ToolboxButtons;
}(_react.default.Component);

exports.default = ToolboxButtons;

var tabListObjectPropTypes = _propTypes.default.shape({
  complete: _propTypes.default.bool,
  textAlias: _propTypes.default.string,
  time: _propTypes.default.string
});

ToolboxButtons.propTypes = {
  deviceType: _propTypes.default.string,
  vehicleId: _propTypes.default.string,
  pageAlias: _propTypes.default.string,
  tabList: _propTypes.default.shape({
    accessories: tabListObjectPropTypes,
    finance: tabListObjectPropTypes,
    prequal: tabListObjectPropTypes,
    payment: tabListObjectPropTypes,
    protect: tabListObjectPropTypes,
    reserve: tabListObjectPropTypes,
    trade: tabListObjectPropTypes
  }),
  vehicleInfo: _propTypes.default.shape({
    bodyStyle: _propTypes.default.shape({
      _type: _propTypes.default.string,
      en_US: _propTypes.default.string
    }),
    chromeId: _propTypes.default.string,
    internetPrice: _propTypes.default.number,
    make: _propTypes.default.string,
    model: _propTypes.default.shape({
      _type: _propTypes.default.string,
      en_US: _propTypes.default.string
    }),
    normalBodyStyle: _propTypes.default.shape({
      _type: _propTypes.default.string,
      en_US: _propTypes.default.string
    }),
    trim: _propTypes.default.shape({
      _type: _propTypes.default.string,
      en_US: _propTypes.default.string
    }),
    type: _propTypes.default.string,
    uuid: _propTypes.default.string,
    vin: _propTypes.default.string,
    year: _propTypes.default.string
  }),
  paymentInfo: _propTypes.default.arrayOf(_propTypes.default.shape({
    payments: _propTypes.default.arrayOf(_propTypes.default.shape({
      annualMiles: _propTypes.default.number,
      apr: _propTypes.default.number,
      downPayment: _propTypes.default.number,
      financeType: _propTypes.default.string,
      lenderLegalName: _propTypes.default.string,
      payment: _propTypes.default.number,
      programEndDate: _propTypes.default.string
    }))
  })),
  locale: _propTypes.default.string,
  widgetClasses: _propTypes.default.string
};
ToolboxButtons.defaultProps = {
  deviceType: 'DESKTOP',
  vehicleId: '',
  pageAlias: '',
  tabList: {},
  vehicleInfo: {},
  paymentInfo: [],
  widgetClasses: '',
  locale: 'en_US'
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = __webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Toolbox = _interopRequireDefault(__webpack_require__(14));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer() {
    _classCallCheck(this, WidgetContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).apply(this, arguments));
  }

  _createClass(WidgetContainer, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_Toolbox.default, this.props);
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

WidgetContainer.propTypes = {
  deviceType: _propTypes.default.string.isRequired,
  vehicleId: _propTypes.default.string.isRequired,
  pageAlias: _propTypes.default.string.isRequired,
  tabList: _propTypes.default.shape({
    accessories: _propTypes.default.shape({
      complete: _propTypes.default.bool,
      textAlias: _propTypes.default.string,
      time: _propTypes.default.string
    }),
    finance: _propTypes.default.shape({
      complete: _propTypes.default.bool,
      textAlias: _propTypes.default.string,
      time: _propTypes.default.string
    }),
    prequal: _propTypes.default.shape({
      complete: _propTypes.default.bool,
      textAlias: _propTypes.default.string,
      time: _propTypes.default.string
    }),
    payment: _propTypes.default.shape({
      complete: _propTypes.default.bool,
      textAlias: _propTypes.default.string,
      time: _propTypes.default.string
    }),
    protect: _propTypes.default.shape({
      complete: _propTypes.default.bool,
      textAlias: _propTypes.default.string,
      time: _propTypes.default.string
    }),
    reserve: _propTypes.default.shape({
      complete: _propTypes.default.bool,
      textAlias: _propTypes.default.string,
      time: _propTypes.default.string
    }),
    trade: _propTypes.default.shape({
      complete: _propTypes.default.bool,
      textAlias: _propTypes.default.string,
      time: _propTypes.default.string
    })
  }).isRequired,
  vehicleInfo: _propTypes.default.shape({
    bodyStyle: _propTypes.default.shape({
      _type: _propTypes.default.string,
      en_US: _propTypes.default.string
    }),
    chromeId: _propTypes.default.string,
    internetPrice: _propTypes.default.number,
    make: _propTypes.default.string,
    model: _propTypes.default.shape({
      _type: _propTypes.default.string,
      en_US: _propTypes.default.string
    }),
    normalBodyStyle: _propTypes.default.shape({
      _type: _propTypes.default.string,
      en_US: _propTypes.default.string
    }),
    trim: _propTypes.default.shape({
      _type: _propTypes.default.string,
      en_US: _propTypes.default.string
    }),
    type: _propTypes.default.string,
    uuid: _propTypes.default.string,
    vin: _propTypes.default.string,
    year: _propTypes.default.string
  }).isRequired,
  paymentInfo: _propTypes.default.arrayOf(_propTypes.default.shape({
    payments: _propTypes.default.arrayOf(_propTypes.default.shape({
      annualMiles: _propTypes.default.number,
      apr: _propTypes.default.number,
      downPayment: _propTypes.default.number,
      financeType: _propTypes.default.string,
      lenderLegalName: _propTypes.default.string,
      payment: _propTypes.default.number,
      programEndDate: _propTypes.default.string
    }))
  })).isRequired,
  locale: _propTypes.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    deviceType: state.requestData.deviceType,
    vehicleId: state.vehicleId,
    pageAlias: state.pageAlias,
    tabList: state.tabList,
    vehicleInfo: state.vehicleInfo,
    paymentInfo: state.paymentInfo,
    widgetClasses: state.widgetClasses,
    locale: state.locale
  };
};

var mapDispatchToProps = function mapDispatchToProps(_dispatch) {
  return {};
};

var Widget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);
var _default = Widget;
exports.default = _default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vehicleId = _interopRequireDefault(__webpack_require__(23));

var _pageAlias = _interopRequireDefault(__webpack_require__(20));

var _tabList = _interopRequireDefault(__webpack_require__(22));

var _pricingInfo = _interopRequireDefault(__webpack_require__(21));

var _vehicleInfo = _interopRequireDefault(__webpack_require__(24));

var _widgetClasses = _interopRequireDefault(__webpack_require__(25));

var _locale = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  vehicleId: _vehicleId.default,
  pageAlias: _pageAlias.default,
  tabList: _tabList.default,
  paymentInfo: _pricingInfo.default,
  vehicleInfo: _vehicleInfo.default,
  widgetClasses: _widgetClasses.default,
  locale: _locale.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = locale;

var _types = __webpack_require__(1);

function locale() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_LOCALE:
        return action.payload;

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pageAlias;

var _types = __webpack_require__(1);

function pageAlias() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_PAGE_ALIAS:
        return action.payload;

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = paymentInfo;

var _types = __webpack_require__(1);

// TODO: change to use ES6 arrow functions 
function paymentInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case _types.SET_PAYMENT_INFO:
        return action.payload;

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tabList;

var _types = __webpack_require__(1);

// TODO: change to use ES6 arrow functions
function tabList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case _types.SET_TAB_LIST:
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = vehicleId;

var _types = __webpack_require__(1);

function vehicleId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_VEHICLE_ID:
        return action.payload;

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = vehicleInfo;

var _types = __webpack_require__(1);

// TODO: change to use ES6 arrow functions 
function vehicleInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case _types.SET_VEHICLE_INFO:
        return action.payload;

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetClasses;

var _types = __webpack_require__(1);

function widgetClasses() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case _types.SET_WIDGET_CLASSES:
        return action.payload;

      default:
        return state;
    }
  }

  return state;
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(47);

var _reduxThunk = _interopRequireDefault(__webpack_require__(48));

var _reducers = _interopRequireDefault(__webpack_require__(18));

var _requestData = _interopRequireDefault(__webpack_require__(31));

var _prefs = _interopRequireDefault(__webpack_require__(30));

var _labels = _interopRequireDefault(__webpack_require__(29));

var _sitemap = _interopRequireDefault(__webpack_require__(32));

var _flags = _interopRequireDefault(__webpack_require__(28));

var _middleware = _interopRequireDefault(__webpack_require__(17));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-dr-toolbox - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(42),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetComponents = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(4);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(27));

var _Collapse = _interopRequireDefault(__webpack_require__(26));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var getWidgetComponents = function getWidgetComponents(Widget, store, widgetId) {
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(Widget, null))));
};

exports.getWidgetComponents = getWidgetComponents;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(40)


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(39);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(41);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(38);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = DDC.WsmCommonData;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = ReactBootstrap;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.4dccd6934519cb426a95.js